import { useTranslation } from 'react-i18next';
import { InfiosChip, InfiosIcon, InfiosLink } from '@infios/uikit/react';
import type { Citation } from '../../interfaces/chat';
import styles from './CitationChips.module.css';

interface CitationChipsProps {
  citations: Citation[];
}

/** Verified-source attributions emitted as chat.citation events for a turn. */
export function CitationChips({ citations }: CitationChipsProps) {
  const { t } = useTranslation();
  if (!citations.length) return null;

  return (
    <div className={styles.wrap}>
      <div className={styles.heading}>
        <InfiosIcon name="link-variant" />
        <span>{t('ChatbotUI.Sources')}</span>
      </div>
      <ul className={styles.list}>
        {citations.map((c, i) => {
          const body = (
            <>
              <InfiosChip
                size="compact"
                prefixIcon={c.verified ? 'check-circle' : 'alert-circle-outline'}
                backgroundColor={c.verified ? 'var(--chat-success-subtle)' : 'var(--chat-warning-subtle)'}
                textColor={c.verified ? 'var(--chat-success)' : 'var(--chat-warning)'}
                title={c.reason ?? undefined}
              >
                {c.verified ? t('ChatbotUI.SourceVerified') : t('ChatbotUI.SourceUnverified')}
              </InfiosChip>
              <span className={styles.title}>{c.sourceTitle || c.sourceId}</span>
            </>
          );
          return (
            <li key={`${c.sourceId}-${i}`} className={styles.item}>
              {c.sourceUrl ? (
                <InfiosLink href={c.sourceUrl} target="_blank" showIcon className={styles.link}>
                  {body}
                </InfiosLink>
              ) : (
                <span className={styles.link}>{body}</span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
